"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Folder = _interopRequireDefault(require("@material-ui/icons/Folder"));

var _People = _interopRequireDefault(require("@material-ui/icons/People"));

var _Star = _interopRequireDefault(require("@material-ui/icons/Star"));

var _Schedule = _interopRequireDefault(require("@material-ui/icons/Schedule"));

var _OfflinePin = _interopRequireDefault(require("@material-ui/icons/OfflinePin"));

var _Publish = _interopRequireDefault(require("@material-ui/icons/Publish"));

var _Backup = _interopRequireDefault(require("@material-ui/icons/Backup"));

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _Settings = _interopRequireDefault(require("@material-ui/icons/Settings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var list = [{
  primaryText: 'My Files',
  icon: /*#__PURE__*/_react["default"].createElement(_Folder["default"], null)
}, {
  primaryText: 'Shared with me',
  icon: /*#__PURE__*/_react["default"].createElement(_People["default"], null)
}, {
  primaryText: 'Starred',
  icon: /*#__PURE__*/_react["default"].createElement(_Star["default"], null)
}, {
  primaryText: 'Recent',
  icon: /*#__PURE__*/_react["default"].createElement(_Schedule["default"], null)
}, {
  primaryText: 'Offline',
  icon: /*#__PURE__*/_react["default"].createElement(_OfflinePin["default"], null)
}, {
  primaryText: 'Uploads',
  icon: /*#__PURE__*/_react["default"].createElement(_Publish["default"], null)
}, {
  primaryText: 'Backups',
  icon: /*#__PURE__*/_react["default"].createElement(_Backup["default"], null)
}, {
  primaryText: 'Trash',
  icon: /*#__PURE__*/_react["default"].createElement(_Delete["default"], null)
}];

var NavContentEx = function NavContentEx(_ref) {
  var onClickItem = _ref.onClickItem;
  return /*#__PURE__*/_react["default"].createElement(_List["default"], null, list.map(function (_ref2, i) {
    var primaryText = _ref2.primaryText,
        icon = _ref2.icon;
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      key: primaryText,
      selected: i === 0,
      button: true,
      onClick: onClickItem
    }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, icon)), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: primaryText,
      primaryTypographyProps: {
        noWrap: true
      }
    }));
  }), /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
    style: {
      margin: '12px 0'
    }
  }), /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    button: true,
    onClick: onClickItem
  }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_Settings["default"], null)), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    primary: 'Settings & account',
    primaryTypographyProps: {
      noWrap: true
    }
  })));
};

NavContentEx.propTypes = {};
NavContentEx.defaultProps = {};
var _default = NavContentEx;
exports["default"] = _default;